import { Tooltip } from '@heroui/react';
import { memo } from 'react';

const InputText = ({
  name,
  title,
  required,
  placeholder,
  value,
  errors,
  touched,
  handleChange,
  handleBlur,
  disabled,
  tooltip = null,
  endIcon = null,
  dir,
}) => {
  return (
    <div className="flex flex-col items-start gap-1.5 w-full relative">
      <div className="flex flex-row items-center gap-1 relative">
        <label className="titleInput">{title}</label>
        {required && <p className="text-error text-sm">اجباری</p>}
        {tooltip && (
          <Tooltip content={tooltip}>
            <button className="mr-1 text-xs text-blackFont-700 bg-blackFont-100 hover:bg-blackFont-700 hover:text-blackFont-100 transition-all px-2 py-1 rounded-full">
              راهنما
            </button>
          </Tooltip>
        )}
      </div>
      <div
        className={`
            ${errors && touched ? 'border-error' : 'border-light-grey dark:border-blackFont-700'}
            disabled:bg-light-grey/50 dark:disabled:bg-blackFont-800/60 border-[1px] rounded-lg py-2 px-4 h-[48px] w-full placeholder:text-text-normal/70 dark:placeholder:text-blackFont-400 placeholder:font-light text-text-hard dark:text-white text-base transition-all flex items-center justify-between gap-2 relative bg-white dark:bg-blackFont-800`}
      >
        <input
          disabled={disabled}
          name={name}
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}
          type="text"
          dir={dir}
          className="w-full h-full bg-transparent appearance-none text-text-hard dark:text-white placeholder:text-text-normal/70 dark:placeholder:text-blackFont-400"
          placeholder={placeholder}
        />
        {endIcon && endIcon}
      </div>
      {errors && touched && <p className="absolute -bottom-5 text-xs text-error">{errors}</p>}
    </div>
  );
};

export default memo(InputText);
